import DefaultPage from "./default-page.jsx";
import ContactMailLink from "../organisms/contact-mail-link.jsx";
import { Typography } from "@mui/material";

export default function Contact() {
  return (
    <DefaultPage>
      <br />
      <Typography variant="h4" align="center">
        Kontakt
      </Typography>
      <br />
      <ContactMailLink align="center" />
      <br />
    </DefaultPage>
  );
}
